import { IRendererConfig } from './IRendererConfig';

const COLOR_PALETTE = {
  GRAY: '#DDDDDD',
  YELLOW: '#EEDC00',
  ORANGE: '#F0AD4E',
  RED: "#C63527",
  LIGHT_BLUE: '#55C1E9', 
  BLUE: '#6677EE',
  PURPLE: '#AA66EE',
}

export const ACTION_STATUS_CONFIG: IRendererConfig = {
  lookupTable: ['#DDDDDD', "#6677EE", "#AA66EE", "#EEAA00", "#DD5555"],
  issues: [
    'NoIssue',
    'ContMonitor',
    'ContMonitorDue',
    'SchedRemoval',
    'SchedRemovalDue',
  ],
};

export const RECOMMENDED_ACTION_CONFIG = {
  lookupTable: ["#DDDDDD", "#6677EE", "#E0D400", "#E08E23", "#DD5555"],
  issues: [
    'NoIssue',
    'ContMonitor',
    'SchedRemoval30',
    'SchedRemoval7',
    'SchedRemoval1',
  ],
};

export const THREAD_WEAR_TRESHOLD_CONFIG = {
  lookupTable: ["#DDDDDD", '#6677ee', "#EEDC00", '#C63527', "#AA66EE"],
  issues: [
    'NoIssue',
    'tw_low_tread_tyre_note',
    'LowAsymmetricWear',
    'HighAsymmetricWear',
    'tw_worn_out_tyre_note',
  ],
};

export const TREAT_MATCHING_ISSUE_CONFIG = {
  lookupTable: ["#DDDDDD", "#F0AD4E"],
  issues: ['NoIssue', 'tw_tread_matching_issue'],
};

export const DEFAULT_CONFIG = {
  lookupTable: ['#DDDDDD'],
  issues: ['NoIssue'],
};
